import React, { useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon as MenuIcon, XMarkIcon as XIcon } from '@heroicons/react/24/outline';
import { LanguageContext } from '../../App';
import Logo from '../common/Logo';

const translations = {
  en: {
    home: 'Home',
    services: 'Our Services',
    stories: 'Stories',
    blog: 'Blog',
    contact: 'Contact',
    donate: 'Donate',
    aboutUs: 'About Us',
    organization: 'Radhe Krishna Sewa Samiti Trust'
  },
  hi: {
    home: 'होम',
    services: 'हमारी सेवाएं',
    stories: 'कहानियां',
    blog: 'ब्लॉग',
    contact: 'संपर्क करें',
    donate: 'दान करें',
    aboutUs: 'हमारे बारे में',
    organization: 'राधे कृष्णा सेवा समिति ट्रस्ट'
  }
};

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language, setLanguage } = useContext(LanguageContext);
  const location = useLocation();

  const t = translations[language];

  const menuItems = [
    { name: t.home, path: '/' },
    { name: t.services, path: '/services' },
    { name: t.stories, path: '/stories' },
    { name: t.blog, path: '/blog' },
    { name: t.contact, path: '/contact' },
    { name: t.aboutUs, path: '/about' },
  ];

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'hi' : 'en');
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <nav className="container-custom">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Logo language={language} />

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-hindi text-gray-700 hover:text-primary transition-colors ${
                  location.pathname === item.path ? 'text-primary font-semibold' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={toggleLanguage}
              className="relative px-4 py-2 rounded-full bg-gradient-to-r from-primary to-secondary text-white overflow-hidden group transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              <span className="relative z-10 flex items-center justify-center">
                <span className={`transition-transform duration-300 ${language === 'en' ? 'translate-y-0' : 'translate-y-8'}`}>
                  हिंदी
                </span>
                <span className={`absolute inset-0 flex items-center justify-center transition-transform duration-300 ${language === 'en' ? '-translate-y-8' : 'translate-y-0'}`}>
                  English
                </span>
              </span>
              <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <XIcon className="h-6 w-6 text-gray-600" />
            ) : (
              <MenuIcon className="h-6 w-6 text-gray-600" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t">
            <div className="container-custom py-4">
              <div className="flex flex-col space-y-4">
                {menuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`font-hindi text-gray-700 hover:text-primary transition-colors ${
                      location.pathname === item.path ? 'text-primary font-semibold' : ''
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <button
                  onClick={() => {
                    toggleLanguage();
                    setIsOpen(false);
                  }}
                  className="px-3 py-1 rounded-md bg-primary text-white hover:bg-opacity-90 transition-colors text-left"
                >
                  {language === 'en' ? 'हिंदी' : 'English'}
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header; 